import React from 'react';
import { Provider } from 'react-redux';

import { IConfig } from './types';

import { configureStore } from './redux/configureStore';

import { App } from './App';

const store = configureStore();

interface IProps {
    config: IConfig;
}

export const HappyEyesCheck: React.FC<IProps> = ({ config }) => (
    <Provider store={store}>
        <App config={config} />
    </Provider>
);
